<template>
  <div class="app-container">
    <div class="mycontainer" style="margin-bottom: 0px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="80px"
        :rules="rules"
      >
        <el-form-item label="统计周期" prop="time">
          <!-- <el-date-picker
            v-model="time[0]"
            style="width: 150px"
            type="date"
            placeholder="开始日期"
            :pickerOptions="pickerOptions"
            @change="onStartChange"
            size="small"
          ></el-date-picker
          >&nbsp; &nbsp;- &nbsp; &nbsp;
          <el-date-picker
            v-model="time[1]"
            style="width: 150px"
            type="date"
            placeholder="结束日期"
            :pickerOptions="pickerOptions"
            @change="onEndChange"
            size="small"
          ></el-date-picker> -->
          <el-date-picker
            v-model="time"
            style="width: 300px"
            type="daterange"
            :pickerOptions="pickerOptions"
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="所属部门" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="listQuery.bmbh"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            @change="bmChange"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键动作" prop="gjdz">
          <el-select
            ref="gjdz"
            v-model="listQuery.gjdz"
            placeholder="全部"
            clearable
            size="small"
            class="filter-item"
          >
            <el-option
              v-for="item in lxList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="统计对象" prop="tjdx">
          <el-select
            ref="tjdx"
            v-model="listQuery.tjdx"
            placeholder="全部"
            size="small"
            class="filter-item"
            @change="handleChangeDx"
          >
            <el-option
              v-for="item in dxList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="区域总监"
          prop="areaDirector"
          v-show="listQuery.tjdx === 2"
        >
          <el-select
            ref="areaDirector"
            v-model="listQuery.areaDirector"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
          >
            <el-option
              v-for="item in areaDirectorList"
              :key="item.xm"
              :label="item.xm"
              :value="item.ygbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList()"
            >查询</el-button
          >
          <el-button
            icon="el-icon-download"
            size="small"
            @click="pstjExport()"
            style="margin-left: 4px"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>

    <div>
      <el-table
        v-show="listQuery.tjdx === 1"
        border
        stripe
        :max-height="height"
        size="mini"
        v-loading="listLoading"
        :data="list"
        fit
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="日期"
          prop="tjzq"
          min-width="140px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="部门名称"
          prop="bmmc"
          min-width="100px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="关键动作"
          prop="name"
          min-width="130px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="计划执行数"
          prop="zxs"
          min-width="90px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="提交评审数"
          prop="tjs"
          min-width="90px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="已评审数"
          prop="pss"
          min-width="80px"
          align="center"
        ></el-table-column>
        <el-table-column label="一次评审通过数" align="center">
          <el-table-column
            label="小计"
            prop="ystg"
            min-width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="优秀"
            prop="ysyx"
            min-width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="良好"
            prop="yslh"
            min-width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="一般"
            prop="ysyb"
            min-width="60px"
            align="center"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="二次评审通过数" align="center">
          <el-table-column
            label="小计"
            prop="estg"
            min-width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="优秀"
            prop="esyx"
            min-width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="良好"
            prop="eslh"
            min-width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="一般"
            prop="esyb"
            min-width="60px"
            align="center"
          ></el-table-column>
        </el-table-column>
        <el-table-column
          label="不通过数"
          prop="btgs"
          min-width="80px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="提交评审率(%)"
          prop="tjl"
          min-width="100px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="已评审率(%)"
          prop="psl"
          min-width="80px"
          align="center"
        ></el-table-column>
        <el-table-column label="一次评审通过率(%)" align="center">
          <el-table-column
            label="小计"
            prop="ystgl"
            min-width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="优秀"
            prop="ysyxl"
            min-width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="良好"
            prop="yslhl"
            min-width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="一般"
            prop="ysybl"
            min-width="60px"
            align="center"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="二次评审通过率(%)" align="center">
          <el-table-column
            label="小计"
            prop="estgl"
            min-width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="优秀"
            prop="esyxl"
            min-width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="良好"
            prop="eslhl"
            min-width="60px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="一般"
            prop="esybl"
            min-width="60px"
            align="center"
          ></el-table-column>
        </el-table-column>
        <el-table-column
          label="不通过率(%)"
          prop="btgl"
          min-width="80px"
          align="center"
        ></el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <el-table
        v-show="listQuery.tjdx === 2"
        border
        stripe
        :max-height="height"
        size="mini"
        v-loading="listLoading"
        :data="list"
        fit
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="日期"
          prop="tjzq"
          min-width="140px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="部门名称"
          prop="bmmc"
          min-width="100px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="项目名称"
          prop="xmmc"
          min-width="180px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="计划名称"
          prop="jhmc"
          min-width="200px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="关键动作"
          prop="name"
          min-width="130px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="执行人"
          prop="zxr"
          min-width="120px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="评审状态"
          prop="pszt"
          min-width="80px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="评审结果"
          prop="psjg"
          min-width="80px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="评审次数"
          prop="pscs"
          min-width="80px"
          align="center"
        ></el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>
  
<script>
import { getBmxxList } from "@/api/taskType.js";
import { getAreaDirectorList, pstjExport, pstjList } from "@/api/xmReview.js";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import ViewAudit from "./viewAudit.vue";
export default {
  // 列表分页
  name: "auditList",
  components: { Pagination, ViewAudit },
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    // const rolesAllClass = [{ value: 0, name: '超级管理员' }, { value: 1, name: '普通管理员' }, { value: 2, name: '普通员工' }, { value: 3, name: '普通用户' }]
    return {
      height: 100,
      auditStatus: 1,
      listQuery: {
        bmbh: "",
        gjdz: "",
        tjdx: 1,
        areaDirector: "",
        page: 1,
        pageSize: 50,
      },
      listLoading: false,
      total: 0,
      list: [],
      jdlxList: [],
      bmList: [],
      areaDirectorList: [],
      lxList: [
        "效果评估策略制定",
        "效果评估报告编写",
        "对接年度计划",
        "制度评审",
        "规划咨询成果评审",
        "管理咨询成果评审",
      ],
      dxList: [
        { key: 1, value: "分公司" },
        { key: 2, value: "计划任务" },
      ],
      ygtxoptions: [],
      time: [this.getCurrentYearFirst(), Date.now()],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      rules: {
        time0: [{ required: true, message: "请选择时间", trigger: "change" }],
      },
      auditDialog: false,
      viewDialog: false,
      editDialog: false,
      mxParams: {},
    };
  },
  created() {
    getBmxxList("0").then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });
    getAreaDirectorList("").then((res) => {
      if (res.code == 0) {
        this.areaDirectorList = res.data;
      }
    });

    this.$store.dispatch("common/fetchUserInfoAction").then((res) => {
      if (this.user.bmmc.indexOf("分公司") > -1) {
        this.listQuery.bmbh = this.user.bmbh;
      }
      this.getList();
    });
  },
  methods: {
    onStartChange(start) {
      // 开始日期晚于结束日期时，结束日期自动设置为开始日期
      const isAfter = moment(start).isAfter(this.time[1]);
      if (isAfter) {
        this.$set(this.time, 1, start);
      }
    },
    onEndChange(end) {
      // 结束日期早于开始日期时，开始日期自动设置为结束日期
      const isBefore = moment(end).isBefore(this.time[0]);
      if (isBefore) {
        // 赋值需要回显,需使用一下写法
        this.$set(this.time, 0, end);
        //错误写法
        // this.time[0] = end;
        // 语法
        // this.$set(原数组, 索引值, 需要赋的值);
      }
    },
    //月份第一天时间戳
    getCurrentYearFirst() {
      var date = new Date();
      let nowYear = date.getFullYear();
      var date1 = new Date(nowYear, 0, 1);
      return date1;
    },

    handleChangeDx(i) {
      this.listQuery.page = 1;
      if (this.listQuery.tjdx == 1) {
        this.listQuery.areaDirector = "";
      }
      this.getList();
    },
    bmChange() {
      this.listQuery.areaDirector = "";
      getAreaDirectorList({ bmbh: this.listQuery.bmbh }).then((res) => {
        if (res.code == 0) {
          this.areaDirectorList = res.data;
        }
      });
    },
    getList() {
      if (this.time && this.time.length == 2) {
        this.listQuery.qsrq = formatMomentDate(new Date(this.time[0]));
        this.listQuery.jsrq = formatMomentDate(new Date(this.time[1]));
        // if (
        //   this.listQuery.qsrq.slice(0, 4) != this.listQuery.jsrq.slice(0, 4)
        // ) {
        //   this.$message.error("查询的统计周期不能跨年，请重新选择！");
        //   return;
        // }
      } else {
        this.listQuery.qsrq = "";
        this.listQuery.jsrq = "";
        this.$message.error("统计周期不能为空！");
        return;
      }
      this.listLoading = true;
      pstjList(this.listQuery).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 75;
        } else {
          this.$message.error(res.msg);
          this.listLoading = false;
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    pstjExport() {
      if (this.time && this.time.length == 2) {
        this.listQuery.qsrq = formatMomentDate(new Date(this.time[0]));
        this.listQuery.jsrq = formatMomentDate(new Date(this.time[1]));
        // if (
        //   this.listQuery.qsrq.slice(0, 4) != this.listQuery.jsrq.slice(0, 4)
        // ) {
        //   this.$message.error("查询的统计周期不能跨年，请重新选择！");
        //   return;
        // }
      } else {
        this.listQuery.qsrq = "";
        this.listQuery.jsrq = "";
        this.$message.error("统计周期不能为空！");
        return;
      }
      pstjExport(this.listQuery).then((res) => {
        if (res.code == 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        }
      });
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}
#save-form .el-form-item {
  margin-bottom: 20px;
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
</style>

